module.exports = __webpack_public_path__ + "img/Pololab.a0c93ea1.jpg";